import { Component, effect, inject, input } from '@angular/core';
import { StoryblokDirective } from '../../../directives/storyblok.directive';
import { Router } from '@angular/router';
import { SearchInputComponent } from '../../shared/search-input/search-input.component';
import { FeatureFlagService } from '../../../services/feature-flag.service';

@Component({
  selector: 'inexp-hero',
  imports: [StoryblokDirective, SearchInputComponent],
  templateUrl: './hero.component.html',
  styleUrl: './hero.component.scss',
})
export class HeroComponent {
  router = inject(Router);
  _editable = input<string>();
  _uid = input<string>();
  component = input<string>();

  title = input<string>();
  description = input<string>();
  searchPlaceholder = input<string>();
  searchButtonText = input<string>();

  private readonly _featureFlagService = inject(FeatureFlagService);
  readonly isSearchEnabled = this._featureFlagService.createFlagSignal(
    'panorama_inexp_1741_search',
  );

  constructor() {
    effect(() => {
    });
  }

  onSearch(query: string): void {
    this.router.navigate(['/search'], {
      queryParams: { q: query },
    });
  }
}
